Customer.Views ||= {}
Customer.Views.Insights ||= {}

class Customer.Views.Insights.ExportableReportView extends Backbone.View
  el: '#form_report'
  $report: $('#summary-performance-report')

  showLoadingAnimation: ->
    @$report.addClass 'processing'

  hideLoadingAnimation: ->
    @$report.removeClass 'processing'

  showReportError: ->
    showError 'An error occurred while generating this report. Please contact us if the problem persists.'

  activityReportJob: ({data}) =>
    new ResqueJob
      url: @jobURL
      data: data
      success: (results) =>
        @showActivityTable(results)
        @setUpDrillDownLinks()
        @hideLoadingAnimation()
        $('#filters_collapsable').toggleClass('h-0')
        $('#toggleFilter img').toggleClass('hidden')
      error: =>
        @showReportError()
        @hideLoadingAnimation()

  activityReportExcelJob: ({data}, url) =>
    @data = data
    $.post(@infoURL, @data, (response) =>
      @hideLoadingAnimation()
      @showModal(response.steps, response.estimated_time))

  exportConfirm: =>
    @showLoadingAnimation()
    $.ajax
      type: 'POST'
      url: "#{@jobURL}?excel=true"
      data: @data
      success: @showExportStartedMessage
      error: @showReportError

  showModal: (contentAmount, estimatedTime) =>
    modal = new Customer.Reports.ExportModalView({contentAmount: contentAmount, estimatedTime: estimatedTime})
    @$el.append modal.render().el
    modal.show()

  downloadFile: (path) ->
    window.location = path

  disableExportButton: ->
    @$('#activity-export-excel').prop('disabled', 'disabled')

  enableExportButton: ->
    @$('#activity-export-excel').removeProp('disabled')

  setUpDrillDownLinks: =>
    @drillDownView.remove() if @drillDownView
    @drillDownView = new Customer.Views.Insights.ActivityDrillDownView @$el.serializeArray()

  showExportStartedMessage: =>
    @hideLoadingAnimation()
    swal
      title: I18n.t 'customer.reports.modal.export_started_title'
      text: I18n.t 'customer.reports.modal.export_started_message'
      type: 'info'
      html: true
